// extracted by mini-css-extract-plugin
export var form = "_bz-0";